// extracted by mini-css-extract-plugin
export default {"container":"resultsNotFound_container__NasfJ","title":"resultsNotFound_title__n1RPj","img":"resultsNotFound_img__D57EH","btn":"resultsNotFound_btn__dXQs5"};